// removed by extract-text-webpack-plugin
module.exports = {"fallback":"styles__fallback___3Om8d","error":"styles__error___3wBoZ"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/picture/styles.css
// module id = 9yvi
// module chunks = 2